<template>
  <g>
    <g v-if="rand.a.type === hohlschnitt.title">
      <path d="M75 75 q30 175 0 350 q175 -30 350 0 q-30 -175 0 -350 q-175 30 -350 0" stroke="#b1b1b1" stroke-width="1" :fill="material.color.hex"/>
      <polygon v-for="(corner, index) in hohlschnitt.corners" :key="index" :points="corner" stroke="#b1b1b1" stroke-width="2" fill="#fff"/>
    </g>
    <g v-else>
      <rect x="75" y="75" width="350" height="350" stroke="#b1b1b1" stroke-width="1" :fill="material.color.hex"/>
      <g v-for="side in sides" :key="side.id">
        <g v-if="side.rand === saum">
          <path :d="side.saum" stroke-width="1" stroke="#b1b1b1" stroke-dasharray="3,3"/>
          <g v-if="side.rand.oesenArt != inactiveOesen">
            <circle v-for="(item, index) in side.oesenAnzahl" :key="index" :cx="side.oesenAbstand.x(index, side.oesenAnzahl)" :cy="side.oesenAbstand.y(index, side.oesenAnzahl)" r="3" stroke="#b1b1b1" stroke-width="2" fill="#fff" />
          </g>
        </g>
        <path v-if="side.rand === hohlsaum" :d="side.hohlsaum" stroke-width="1" stroke="#b1b1b1"/>
        <g v-if="side.rand === keder" stroke="#b1b1b1" stroke-opacity="0">
          <rect :x="side.keder.outside.xStart" :y="side.keder.outside.yStart" :width="side.keder.outside.width" :height="side.keder.outside.height" fill="#b1b1b1"/>
          <rect :x="side.keder.inside.xStart" :y="side.keder.inside.yStart" :width="side.keder.inside.width" :height="side.keder.inside.height" fill="#8e8e8e"/>
        </g>
      </g>
    </g>
    <g v-for="(side, index) in sides" :key="index">
      <line :x1="side.border.line.xStart" :y1="side.border.line.yStart" :x2="side.border.line.xEnd" :y2="side.border.line.yEnd" stroke="#353535" stroke-width="1"/>
      <polygon :points="side.border.corner.start" stroke="#353535" stroke-width="1" fill="#353535"/>
      <polygon :points="side.border.corner.end" stroke="#353535" stroke-width="1" fill="#353535"/>
    </g>
    <text v-for="side in sides" :key="side.id" :x="side.labelSpace.x" :y="side.labelSpace.y" font-weight="bold" font-family="sans-serif" font-size="2.5em" fill="#232323">{{side.name}}</text>
  </g>
</template>

<script>
import DataRand from './../../../../../data/main/config/setup/rand/randArt'

export default {
  props: ['material', 'rand'],
  data () {
    return {
      hohlschnitt: {
        title: DataRand.randArt.hohlschnitt.title.name,
        corners: {
          cornerLU: '70,80 70,70 80,70',
          cornerRU: '420,70 430,70 430,80',
          cornerLD: '70,420 70,430 80,430',
          cornerRD: '430,420 430,430 420,430'
        }
      },
      saum: DataRand.randArt.saum.titleSaum.name,
      hohlsaum: DataRand.randArt.hohlsaum.title.name,
      keder: DataRand.randArt.keder.title.name,
      inactiveOesen: DataRand.randArt.saum.optionsOesenart[0].value.oesenArt
    }
  },
  computed: {
    sides () {
      return {
        a: {
          name: 'a',
          rand: this.rand.a.type,
          oesenAnzahl: this.rand.a.type === this.saum ? this.rand.a.oesenAnzahl : 0,
          oesenAbstand: {
            x: function (i, item) {
              if (item === 1) {
                return 250
              } else if (item === 2) {
                return 90 + i * 320
              } else {
                return 90 + 320 * (i / (item - 1))
              }
            },
            y: function (i, item) {
              return 410
            }
          },
          saum: 'M75 395 L425 395',
          hohlsaum: 'M75 416 L425 416',
          keder: {
            outside: {
              xStart: 75,
              yStart: 416,
              width: 350,
              height: 9
            },
            inside: {
              xStart: 75,
              yStart: 422,
              width: 350,
              height: 3
            }
          },
          labelSpace: {
            x: 245,
            y: 485
          },
          border: {
            line: {
              xStart: 75,
              yStart: 445,
              xEnd: 425,
              yEnd: 445
            },
            corner: {
              start: '75,445 85,440 85,450',
              end: '425,445 415,440 415,450'
            }
          },
          id: 1
        },
        b: {
          name: 'b',
          rand: this.rand.b.type,
          oesenAnzahl: this.rand.b.type === this.saum ? this.rand.b.oesenAnzahl : 0,
          oesenAbstand: {
            x: function (i, item) {
              return 90
            },
            y: function (i, item) {
              if (item === 1) {
                return 250
              } else if (item === 2) {
                return 90 + i * 320
              } else {
                return 90 + 320 * (i / (item - 1))
              }
            }
          },
          saum: 'M105 75 L105 425',
          hohlsaum: 'M84 75 L84 425',
          keder: {
            outside: {
              xStart: 75,
              yStart: 75,
              width: 9,
              height: 350
            },
            inside: {
              xStart: 75,
              yStart: 75,
              width: 3,
              height: 350
            }
          },
          labelSpace: {
            x: 15,
            y: 250
          },
          border: {
            line: {
              xStart: 55,
              yStart: 75,
              xEnd: 55,
              yEnd: 425
            },
            corner: {
              start: '55,75 50,85 60,85',
              end: '55,425 50,415 60,415'
            }
          },
          id: 2
        },
        c: {
          name: 'c',
          rand: this.rand.c.type,
          oesenAnzahl: this.rand.c.type === this.saum ? this.rand.c.oesenAnzahl : 0,
          oesenAbstand: {
            x: function (i, item) {
              if (item === 1) {
                return 250
              } else if (item === 2) {
                return 90 + i * 320
              } else {
                return 90 + 320 * (i / (item - 1))
              }
            },
            y: function (i, item) {
              return 90
            }
          },
          saum: 'M75 105 L425 105',
          hohlsaum: 'M75 84 L425 84',
          keder: {
            outside: {
              xStart: 75,
              yStart: 75,
              width: 350,
              height: 9
            },
            inside: {
              xStart: 75,
              yStart: 75,
              width: 350,
              height: 3
            }
          },
          labelSpace: {
            x: 245,
            y: 40
          },
          border: {
            line: {
              xStart: 75,
              yStart: 55,
              xEnd: 425,
              yEnd: 55
            },
            corner: {
              start: '75,55 85,50 85,60',
              end: '425,55 415,50 415,60'
            }
          },
          id: 3
        },
        d: {
          name: 'd',
          rand: this.rand.d.type,
          oesenAnzahl: this.rand.d.type === this.saum ? this.rand.d.oesenAnzahl : 0,
          oesenAbstand: {
            x: function (i, item) {
              return 410
            },
            y: function (i, item) {
              if (item === 1) {
                return 250
              } else if (item === 2) {
                return 90 + i * 320
              } else {
                return 90 + 320 * (i / (item - 1))
              }
            }
          },
          saum: 'M395 75 L395 425',
          hohlsaum: 'M416 75 L416 425',
          keder: {
            outside: {
              xStart: 416,
              yStart: 75,
              width: 9,
              height: 350
            },
            inside: {
              xStart: 422,
              yStart: 75,
              width: 3,
              height: 350
            }
          },
          labelSpace: {
            x: 455,
            y: 250
          },
          border: {
            line: {
              xStart: 445,
              yStart: 75,
              xEnd: 445,
              yEnd: 425
            },
            corner: {
              start: '445,75 440,85 450,85',
              end: '445,425 440,415 450,415'
            }
          },
          id: 4
        }
      }
    }
  }
}
</script>

<style>
</style>
